<h2>{{ title$ | async | translate }}</h2>
@if (!!existingMemo) {
  <h2>
    {{ "contentType." + existingMemo.type | translate }}
  </h2>
}
<form [formGroup]="form" (ngSubmit)="form.valid && submitMemo()">
  <ca-separator>{{ "newMemo.whoFor" | translate }}</ca-separator>
  <div class="row">
    <ca-avatar-stack
      item-start
      [maxAvatars]="MAX_AVATAR_COUNT"
      [avatars]="customers$ | async | avatars | async"
    ></ca-avatar-stack>
    <button
      type="button"
      ca-action-button
      color="primary"
      (click)="openCustomerSelection()"
    >
      <mat-icon>add</mat-icon>
      {{
        (customers$ | async)
          ? (customers$
            | async
            | customerselection: ("customerDetail.title" | translate))
          : ("newMemo.selectCustomerLabel" | translate)
      }}
    </button>
  </div>
  @if (!(customers$ | async)?.length && (canUseLists$ | async) === true) {
    <button
      type="button"
      ca-action-button
      color="primary"
      id="customerListSelectionTrigger"
      icon="list"
      (click)="openCustomerSelection('lists')"
    >
      <mat-icon>list</mat-icon>
      {{ "newMemo.selectListsLabel" | translate }}
    </button>
  }

  @if ((customers$ | async)?.length > 0 || !!existingMemo) {
    <!-- Media Selection -->
    @if (
      form.get("type")?.value === types.GALLERY ||
      form.get("type")?.value === types.VIDEO
    ) {
      <ca-separator>{{ "memo.details" | translate }}</ca-separator>
      @if (customers$ | async | allowphotos) {
        <div class="mb-4">
          @for (item of mediaItems; track item) {
            <div
              class="media-item-container"
              [class.has-error]="item.hasError$ | async"
            >
              @if (item.hasError$ | async; as hasError) {
                @if (item.errorMessage$ | async; as errorMessage) {
                  <ca-image-preview
                    [url]="item.url"
                    [progress]="item.progress$ | async"
                  >
                  </ca-image-preview>
                  <ca-media-upload-error-overlay
                    [errorMessage]="errorMessage"
                    (retry)="retryUpload(item.id)"
                    (remove)="promptRemove(item.id)"
                  ></ca-media-upload-error-overlay>
                }
              } @else {
                <ca-image-preview
                  [url]="item.url"
                  [progress]="item.progress$ | async"
                  (click)="promptRemove(item.id)"
                  class="clickable"
                >
                </ca-image-preview>
              }
            </div>
          }
        </div>
        <!-- Image Selection -->
        @if (form.get("type")?.value === types.GALLERY) {
          <ca-file-picker
            [accept]="IMAGE_TYPES"
            [multiple]="true"
            [label]="'newMemo.attachPhoto' | translate"
            iconName="add_a_photo"
            (selection)="addPhotos($event)"
          ></ca-file-picker>
        }
        <!-- Video Selection -->
        @if (form.get("type")?.value === types.VIDEO) {
          <ca-file-picker
            accept="video/*"
            [label]="'newMemo.attachVideo' | translate"
            [multiple]="false"
            iconName="add_a_photo"
            (selection)="addVideo($event)"
          ></ca-file-picker>
        }
      } @else {
        <mat-list>
          @switch ((customers$ | async)?.length || 0) {
            @case (0) {
              <mat-list-item>
                {{ "newMemo.photosBlockedNoCustomer" | translate }}
              </mat-list-item>
            }
            @default {
              <mat-list-item>
                {{ "newMemo.photosBlocked" | translate }}
              </mat-list-item>
            }
          }
        </mat-list>
      }
    }
    <!-- Message Content -->
    <div class="textareaWithActions">
      <div
        class="inputContainer"
        [class.hasError]="
          form.get('body')?.invalid && form.get('body')?.touched
        "
      >
        <ca-form-field class="comment">
          <textarea
            formControlName="body"
            [aria-label]="'memo.details' | translate"
            rows="4"
            caInput
            [onLightBackground]="true"
            [placeholder]="
              (form.get('type')?.value === types.NOTE
                ? 'newMemo.noteBodyPlaceholder'
                : 'newMemo.mediaBodyPlaceholder'
              ) | translate
            "
          ></textarea>
          <button
            ca-action-button
            [disabled]="form.value?.body?.length === 0"
            (click)="getAiSuggestion()"
            type="button"
            color="primary"
            class="actionButton"
          >
            <ca-icon [name]="'ca-magic'"></ca-icon>
            {{ "ai.fixWithAi" | translate }}
          </button>
        </ca-form-field>
      </div>
    </div>
    <!-- Sharing. Can only be done in this form when creating a memo. -->
    <div class="memo-checkboxes">
      @if (!existingMemo) {
        @if (showShareOption$ | async) {
          <mat-checkbox formControlName="shared">
            {{ "newMemo.share" | translate }}
          </mat-checkbox>
        }
      }
      <mat-checkbox formControlName="sensitive">
        {{ "newMemo.sensitive" | translate }}
      </mat-checkbox>
    </div>
    <!-- Relates To -->
    <ca-separator>{{ "memo.relatesTo" | translate }}</ca-separator>
    <ca-memo-relates-to-selector
      (values)="categoriesChanged($event)"
      [categories]="memoCategories$ | async | sortBy: 'ordinal'"
      [loading]="memoCategoriesLoading$ | async"
      [selected]="form.get('categoryIds')?.value"
    ></ca-memo-relates-to-selector>
    <!-- Actions -->
    <div class="actions">
      @if (loading$ | async) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      } @else {
        <button
          [disabled]="form.invalid || (loading$ | async) || !submissionEnabled"
          class="submit"
          ca-raised-button
          color="primary"
        >
          Publish
        </button>
      }
    </div>
  }
</form>

<ng-template #confirmationDialog>
  <h1 mat-dialog-title>Remove?</h1>
  <div mat-dialog-content>
    <p>Do you really want to remove this item?</p>
  </div>
  <div mat-dialog-actions>
    <button type="button" ca-action-button mat-dialog-close>No</button>
    <button
      type="button"
      ca-action-button
      [mat-dialog-close]="true"
      cdkFocusInitial
    >
      Yes
    </button>
  </div>
</ng-template>
